import styled from 'styled-components'
import { Modal } from 'antd'
import { colors } from 'Styled/variables'

export const ModalContainer = styled(Modal)<{ modalHeaderGreen: boolean }>`
  .ant-modal-content {
    width: 600px;
    border-radius: 8px;

    .ant-modal-close {
      display: ${({ modalHeaderGreen }) =>
        modalHeaderGreen ? `flex` : `none`};
      align-items: center;
      justify-content: center;

      .ant-modal-close-x {
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${colors.white};
        opacity: 0.5;

        svg {
          width: 10px;
          height: 10px;
        }
      }
    }
    .ant-modal-header {
      padding: 16.5px 24px;
      border-radius: 8px 8px 0 0;
      background-color: ${({ modalHeaderGreen }) =>
        modalHeaderGreen ? colors.green : 'transparent'};
      border: ${({ modalHeaderGreen }) =>
        !modalHeaderGreen ? `none` : `border: 1px solid #f0f0f0`};

      .ant-modal-title {
        font-size: 18px;
        font-weight: 400;
        color: ${({ modalHeaderGreen }) =>
          modalHeaderGreen ? colors.white : colors.mainText};
      }
    }
    .ant-modal-body {
      padding: 0;
      border-radius: 0 0 8px 8px;
    }
    .ant-modal-footer {
      display: none;
    }
  }
`

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 12px 1fr;
  gap: 22px;
  align-items: start;
  margin-bottom: 31px;
  margin-left: 14px;
`

export const BackButton = styled.img`
  margin-right: 22px;
  width: 12px;
  height: 12px;
  align-self: center;
`

export const HeaderTitle = styled.h4`
  font-size: 20px;
  font-weight: 600;
  color: ${colors.mainText};
  line-height: 30px;
  align-self: center;
`

export const MobileModalContainer = styled.div`
  padding: 16px;
  background: ${colors.white};
  border-radius: 4px;
`
